module.exports = __webpack_public_path__ + "6ae1a65065a7e693c6b4eddaa75f8aa6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/frust.svg
// module id = 12
// module chunks = 0